//import $ from 'jquery';
// export for others scripts to use

// We need to take this workaround,
// because these libs are not available as global variables
// when imported locally via a script tag
// https://cdn.kiprotect.com/klaro/v0.7.9/klaro-no-css.js
window.klaro = require('/js/vendor/klaro-no-css.js');
window.Swiper = require('/js/vendor/swiper-bundle.min.js');
window.Chart = require('/js/vendor/Chart.min.js');


